import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var BussinessAreaRes;
export const BussinessAreaTodo = createAsyncThunk('BussinessArea', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'business_area_list',
            data: {
              "vcustomer_code": ""
            },
            headers: { "Content-Type": "application/json" }
        })
        return BussinessAreaRes = res.data

    } catch (error) {
        return BussinessAreaRes = error.response.data
    }
})

const BussinessAreaSlice = createSlice({
    name: 'BussinessArea',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(BussinessAreaTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(BussinessAreaTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default BussinessAreaSlice.reducer; 